import dayjs from 'dayjs'

export function expiryCheck (expiry) {
  var customParseFormat = require('dayjs/plugin/customParseFormat')
  dayjs.extend(customParseFormat)

  const inputDate = dayjs(`${expiry.slice(2)}-20${expiry.slice(0, 2)}`, 'MM-YYYY', true).startOf('month')
  const currentDate = dayjs().startOf('month')

  const isInputValid = inputDate.isValid() &&
    Number(expiry.slice(2)) > 0 &&
    Number(expiry.slice(2)) <= 12

  console.log(`${expiry.slice(2)}-20${expiry.slice(0, 2)}`)
  if (isInputValid && inputDate.diff(currentDate) >= 0) {
    return true
  }
  return false
}

export const cardPanCheck = (function (arr) {
  return function (ccNum) {
    let len = ccNum.length
    let bit = 1
    let sum = 0
    let val

    while (len) {
      val = parseInt(ccNum.charAt(--len), 10)
                sum += (bit ^= 1) ? arr[val] : val // eslint-disable-line
    }

    return sum && sum % 10 === 0
  }
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]))
